import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Youtube } from "@cinch-labs/design-system";
import { GalleryIcon } from "@cinch-nx/design-system-icons";
import { useVehicleGallery, useModal } from "../../hooks";
import styles from "./media.module.css";
import { getStoryblokImageServiceUrl } from "@cinch-nx/data-storyblok";
export var Media = function(param) {
    var imageCount = param.imageCount, imageSrc = param.imageSrc, title = param.title, alt = param.alt, video = param.video;
    var ref;
    var open = useModal().open;
    var ref1 = useVehicleGallery(), setImageIndex = ref1.setImageIndex, imageIndexes = ref1.imageIndexes;
    var ref2;
    var youtubeVideo = (ref2 = video === null || video === void 0 ? void 0 : video[0]) !== null && ref2 !== void 0 ? ref2 : {};
    var videoId = youtubeVideo.videoId, videoTitle = youtubeVideo.title, buttonLabel = youtubeVideo.buttonLabel, thumbnail = youtubeVideo.thumbnail;
    var propsExist = videoId && videoTitle && buttonLabel && (thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.filename);
    var shouldShowImage = youtubeVideo && Object.keys(youtubeVideo).length === 0;
    var getImageIndex = function() {
        switch(title){
            case "Interior":
                return (imageIndexes === null || imageIndexes === void 0 ? void 0 : imageIndexes.interiorSectionImageIndex) || 0;
            case "Performance":
                return (imageIndexes === null || imageIndexes === void 0 ? void 0 : imageIndexes.performanceSectionImageIndex) || 0;
            case "Practicality":
                return (imageIndexes === null || imageIndexes === void 0 ? void 0 : imageIndexes.practicalitySectionImageIndex) || 0;
            case "Running costs":
                return (imageIndexes === null || imageIndexes === void 0 ? void 0 : imageIndexes.runningCostsSectionImageIndex) || 0;
            default:
                return 0;
        }
    };
    var handleClick = function() {
        var _ref = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!title) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            setImageIndex(getImageIndex())
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        open();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.mediaContainer,
                children: shouldShowImage && imageSrc && /*#__PURE__*/ _jsxs("button", {
                    onClick: handleClick,
                    children: [
                        /*#__PURE__*/ _jsx("img", {
                            src: getStoryblokImageServiceUrl(imageSrc, {
                                filters: [
                                    {
                                        quality: 80
                                    }
                                ]
                            }),
                            alt: alt,
                            className: styles.mediaImage
                        }),
                        /*#__PURE__*/ _jsxs("span", {
                            className: styles.mediaImageInfo,
                            children: [
                                /*#__PURE__*/ _jsx(GalleryIcon, {}),
                                "Gallery (",
                                imageCount,
                                ")"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.videoContainer,
                children: !shouldShowImage && propsExist && /*#__PURE__*/ _jsx(Youtube, {
                    videoId: videoId,
                    title: videoTitle,
                    buttonLabel: buttonLabel,
                    className: styles.video,
                    customThumbnail: getStoryblokImageServiceUrl((thumbnail === null || thumbnail === void 0 ? void 0 : (ref = thumbnail.filename) === null || ref === void 0 ? void 0 : ref.length) ? thumbnail.filename : imageSrc, {
                        filters: [
                            {
                                quality: 80
                            }
                        ]
                    }),
                    videoUrlOptions: {
                        autoplay: 1
                    },
                    showNewPlayIcon: true
                })
            })
        ]
    });
};
